import { useMemo } from "react";

const COLORS = ["#15FF73", "#FF1A8C", "#00E0F5", "#FF7A3D", "#FFE74C", "#C4B5FD"];

export default function Confetti({ count = 28 }) {
  const pieces = useMemo(() =>
    Array.from({ length: count }).map((_, i) => ({
      id: i,
      left: Math.random() * 100,
      delay: Math.random() * 0.6,
      color: COLORS[i % COLORS.length],
      rot: Math.random() * 90,
    })), [count]
  );
  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden z-50">
      {pieces.map((p) => (
        <span
          key={p.id}
          className="confetti-piece"
          style={{
            left: `${p.left}%`,
            background: p.color,
            animationDelay: `${p.delay}s`,
            transform: `rotate(${p.rot}deg)`,
            borderRadius: p.id % 3 === 0 ? "50%" : "2px",
          }}
        />
      ))}
    </div>
  );
}
